import { openBlock as o, createElementBlock as r, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
};
function l(d, e) {
  return o(), r("svg", n, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "m9 3 3.897 4.5H5.103zm0 12-3.897-4.5h7.794z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
